const env = process.env
const reg = /^GIT_/
const keys = Object.keys(env).filter(item => {
  return reg.test(item)
})

export default function () {
  keys.forEach(key => {
    console.info(`${key}:${env[key]}`)
  })
}
